import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-[#02060D] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#D1B677]/[0.04] rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-xs tracking-[0.4em] uppercase text-[#D1B677] font-medium block mb-8">
            Master Positioning
          </span>
          <blockquote className="font-serif text-white text-3xl sm:text-4xl lg:text-6xl leading-[1.15] tracking-tight mb-12">
            <span className="italic text-[#D1B677]">"</span>
            CountGoa is not a directory.<br />
            It is Goa's bridge to{" "}
            <span className="italic text-[#D1B677]">global business opportunities.</span>
            <span className="italic text-[#D1B677]">"</span>
          </blockquote>

          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto pt-8 border-t border-white/8">
            <div className="text-left">
              <div className="text-xs tracking-[0.3em] uppercase text-[#A1AEBF] mb-2">
                Goa-Based Business?
              </div>
              <p className="text-white text-base mb-5">
                Register for FREE and unlock global business opportunities.
              </p>
              <a
                href="#register"
                data-testid="final-business-cta"
                className="group inline-flex items-center gap-3 px-6 py-3 bg-[#D1B677] text-[#02060D] text-sm font-semibold hover:bg-[#E6CC8A] transition-all"
              >
                Register Free
                <ArrowRight size={16} weight="bold" className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
            <div className="text-left md:text-right">
              <div className="text-xs tracking-[0.3em] uppercase text-[#A1AEBF] mb-2">
                Invest · Partner · Expand?
              </div>
              <p className="text-white text-base mb-5">
                Get started with CountGoa's premium opportunity ecosystem.
              </p>
              <a
                href="#register"
                data-testid="final-investor-cta"
                className="group inline-flex items-center gap-3 px-6 py-3 border border-[#D1B677] text-[#D1B677] text-sm font-semibold hover:bg-[#D1B677] hover:text-[#02060D] transition-all"
              >
                Begin Inquiry
                <ArrowRight size={16} weight="bold" className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
